module.exports = __webpack_public_path__ + "img/004_mac_service.600f2784.png";